
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_2184_941)"}},[_c('path',{attrs:{"d":"M6 1c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm0-1a6 6 0 100 12A6 6 0 006 0zm3.125 4.446l-.71-.705L5.362 6.85 3.823 5.382l-.698.718 2.25 2.159 3.75-3.814z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_2184_941"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    